var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightAltBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 12.5L9.26602 11.05L12.816 7.5H0.666016V5.5H12.816L9.26602 1.95L10.666 0.5L16.666 6.5L10.666 12.5Z",
    fill: "#1D1D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightAltBlue);
export default __webpack_public_path__ + "static/media/arrow_right_alt-blue.63c6028da36c75cf28139273f8b235d1.svg";
export { ForwardRef as ReactComponent };